module.exports = __webpack_public_path__ + "static/img/shacheng.1e640cfb.png";